var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTickWash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 0.320312C14.5099 0.320312 0.319923 14.5103 0.319923 32.0003C0.319923 49.4903 14.5099 63.6803 31.9999 63.6803C49.4899 63.6803 63.6799 49.4903 63.6799 32.0003C63.6799 14.5103 49.4899 0.320312 31.9999 0.320312ZM48.3019 24.3443L29.6899 43.0223C29.0959 43.6163 28.2379 44.0123 27.3799 44.0123C26.5219 44.0123 25.6639 43.6823 25.0699 43.0223L15.6979 33.6503C14.3779 32.3303 14.3779 30.2843 15.6979 28.9643C17.0179 27.6443 19.0639 27.6443 20.3839 28.9643L27.3799 35.9603L43.6819 19.6583C45.0019 18.3383 47.0479 18.3383 48.3679 19.6583C49.6219 20.9783 49.6219 23.0243 48.3019 24.3443Z",
    fill: "#127E40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickWash);
export default __webpack_public_path__ + "static/media/GreenTickWash.210163cc.svg";
export { ForwardRef as ReactComponent };